export default __webpack_public_path__ + "static/media/tutorialMomo-3.4.439f23a9.jpeg";